export const URL_Plan = (`${process.env.REACT_APP_HOST}/plan`)
export const URL_PlanClinic = (`${process.env.REACT_APP_HOST}/planClinic`)